// Status pill: icon + label + colour for an engine state. Animated only while in progress, and never under reduced motion.
import { statusOf, type StatusKind } from "../lib/status";

const ICON: Record<StatusKind, string> = { done: "✓", progress: "◐", waiting: "◷", blocked: "!", stale: "↻", agent: "✦", client: "◉", neutral: "○" };
const CLS: Record<StatusKind, string> = {
  done: "border-done-line bg-done-bg text-done", progress: "border-progress-line bg-progress-bg text-progress", waiting: "border-waiting-line bg-waiting-bg text-waiting",
  blocked: "border-blocked-line bg-blocked-bg text-blocked", stale: "border-stale-line bg-stale-bg text-stale", agent: "border-agent-line bg-agent-bg text-agent",
  client: "border-client-line bg-client-bg text-client", neutral: "border-neutral-line bg-neutral-bg text-neutral",
};

/** `state` is an engine word (done, cannot_run, waiting_client…); `kind`/`label` override the dictionary when a screen needs to. */
export function StatusPill({ state, kind, label, title, live }: { state?: string | null; kind?: StatusKind; label?: string; title?: string; live?: boolean }) {
  const s = statusOf(state);
  const k = kind ?? s.kind;
  return (
    <span title={title} data-status={k} className={`inline-flex items-center gap-1 whitespace-nowrap rounded border px-1.5 py-0.5 text-xs font-medium ${CLS[k]}`}>
      <span aria-hidden="true" className={live && k === "progress" ? "pulse-dot" : undefined}>{ICON[k]}</span>
      {label ?? s.label}
    </span>
  );
}
